import { useState } from "react";
import { api, type ApiError } from "@/lib/api";

/** Aberta pelo link do e-mail: /?reset=<token>. */
export function ResetPasswordPage({ token, onDone }: {
  token: string;
  onDone: () => void;
}): JSX.Element {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError("As senhas não conferem.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/password/reset", { token, newPassword: password });
      setDone(true);
    } catch (err) {
      setError((err as ApiError).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">VG</div>
          <div className="login-title">Nova senha</div>
        </div>
        {done ? (
          <div className="login-form">
            <div className="success">
              Senha alterada. Por segurança, todas as sessões abertas foram encerradas.
            </div>
            <button type="button" className="btn primary" onClick={onDone}>
              Ir para o login
            </button>
          </div>
        ) : (
          <form className="login-form" onSubmit={(e) => void submit(e)}>
            <div className="login-hint">Mínimo de 10 caracteres. Frases longas funcionam bem.</div>
            <label>
              Nova senha
              <input type="password" required minLength={10} autoComplete="new-password" autoFocus
                value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading} />
            </label>
            <label>
              Confirme a nova senha
              <input type="password" required minLength={10} autoComplete="new-password"
                value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={loading} />
            </label>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn primary" disabled={loading}>
              {loading ? "Salvando..." : "Salvar nova senha"}
            </button>
            <button type="button" className="link-btn" onClick={onDone}>Voltar ao login</button>
          </form>
        )}
      </div>
    </div>
  );
}
